import React, { useEffect, useRef, useState } from "react";
import { Toaster, toast } from "react-hot-toast";
import { showToast } from "../../Helpers/showToast";
import { SUPERPOST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";
import { TextField } from "@mui/material";

export default function PasswordDialog({
  modalOpen,
  handleModalClose,
  executeConfirmed,
}) {
  const { cmpdetail } = useSelector((state) => state.CompanyDetail);
      const UserDetail = useSelector((state) => state.UserDetail);
  const Theme = useSelector((state) => state.Theme);
  const itemButtonRef = useRef(null);
  const [Loader, setLoader] = useState(false);

  const [SettingPassword, setSettingPassword] = useState("");

  const EnterSetting = async () => {
    if (!SettingPassword) {
      showToast("Please Enter Password", "error");
      return;
    }

    setLoader(true);

    var requestData = CustomStringify({
      user_name: UserDetail?.result?.user?.user_name,
      password: SettingPassword,
    });

    try {
      const result = await SUPERPOST(`/sellers/lgnvndr/${cmpdetail?.key}`, requestData);

      setLoader(false);
      handleModalClose();
      setSettingPassword("");
      executeConfirmed();
    } catch (error) {
      setLoader(false);
      showToast(error?.response?.data?.message || error?.message, "error");
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && itemButtonRef.current) {
      itemButtonRef.current.click();
    }
  };

  const theme = createTheme({
    breakpoints: {
      values: {
        tab: 992,
      },
    },
    palette: {
      primary: {
        main: Theme.primaryThemeColor,
      },
    },
    typography: {
      fontFamily: "Poppins",
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          input: {
            height: "5px",
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Dialog
        onClose={() => (handleModalClose(), setSettingPassword(""))}
        open={modalOpen}
        maxWidth={"md"}
        PaperProps={{
          style: {
            backgroundColor: "#F6F8FA",
          },
        }}
        sx={{
          backdropFilter: "blur(15px)",
        }}
      >
        <div className="d-flex justify-content-between align-items-center">
          <DialogTitle align="right" sx={{ fontSize: "18px" }}>
            Enter Your Password
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={() => (handleModalClose(true), setSettingPassword(""))}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <DialogContent sx={{ transition: "ease-in-out", pt: 0 }}>
          <TextField
            id="Password"
            placeholder="Password"
            autoFocus
            value={SettingPassword}
            onChange={(e) => setSettingPassword(e.target.value)}
            onKeyDown={handleKeyDown}
            sx={{ width: "100%", my: 1 }}
            type="password"
            autoComplete="new-password"
          />
          <Button
            disabled={Loader ? true : false}
            id="Enter"
            variant="contained"
            align="center"
            ref={itemButtonRef}
            onClick={EnterSetting}
          >
            {Loader ? (
              <CircularProgress
                size="18px"
                sx={{ color: "#000", my: 0.6 }}
              />
            ) : (
              "Enter"
            )}
          </Button>
        </DialogContent>
      </Dialog>
    </ThemeProvider>
  );
}
